export default __webpack_public_path__ + "static/media/icon--chat.fe5eee93.svg";